import { render } from "./PhraseEditor.vue?vue&type=template&id=1712c942"
import script from "./PhraseEditor.vue?vue&type=script&lang=js"
export * from "./PhraseEditor.vue?vue&type=script&lang=js"

import "./PhraseEditor.vue?vue&type=style&index=0&id=1712c942&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/PhraseEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1712c942"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1712c942', __exports__)) {
    api.reload('1712c942', __exports__)
  }
  
  module.hot.accept("./PhraseEditor.vue?vue&type=template&id=1712c942", () => {
    api.rerender('1712c942', render)
  })

}


export default __exports__